export function clearUrl () {
    window.history.pushState({}, "" ,window.location.origin+window.location.pathname)
}